<template>
  <v-container
    id="balances-view"
    fluid
    tag="section"
  >
    <material-card
      icon="$balances"
      icon-small
      color="accent"
      :title="page_title"
    >
      <v-card-title>
        <export-btn
          source-type="balances"
        />
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="$search"
          class="ml-auto"
          hide-details
          :label="$t('search_records')"
          single-line
          style="max-width: 250px;"
        />
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :loading-text="$t('loading')"
          :options.sync="options"
          :server-items-length="total"
          :footer-props="footerProps"
          :item-class="row_classes"
          multi-sort
        >
          <template #item.membership_balance="{item}">
            {{ item.membership_balance | numberFormat }} {{ profile.organization.currency.name }}
          </template>
          <template #item.flight_balance="{item}">
            {{ item.flight_balance | numberFormat }} {{ profile.organization.currency.name }}
          </template>
          <template #item.actions="{item}">
            <tooltip-btn
              v-for="(action, i) in actions"
              :key="i"
              :show="!action.disable"
              :color="action.color"
              :icon="action.icon"
              :tooltip="action.tooltip"
              @click="action.func(item.id)"
            />
          </template>
        </v-data-table>
      </v-card-text>
    </material-card>
  </v-container>
</template>

<script>
  // Utilities
  import { get, call, dispatch, sync } from 'vuex-pathify'
  import ExportBtn from '@/components/ExportBtn'

  export default {
    name: 'Balances',
    components: {
      ExportBtn,
    },
    data () {
      return {
        items: [],
        // table
        footerProps: {
          itemsPerPageOptions: [10, 20, 25, 50, 100, 150],
        },
        total: 0,
        timer: null,
      }
    },
    computed: {
      loading: get('app/loading'),
      profile: get('auth/profile'),
      options: sync('transaction/balance_options'),
      search: sync('transaction/balance_search'),
      headers () {
        return [
          {
            text: this.$t('fields.name'),
            align: 'start',
            sortable: true,
            value: 'name',
          },
          {
            text: this.$t('fields.flight_balance'),
            align: 'right',
            sortable: true,
            value: 'flight_balance',
          },
          {
            text: this.$t('fields.membership_balance'),
            align: 'right',
            sortable: true,
            value: 'membership_balance',
          },
          {
            text: this.$t('actions'),
            value: 'actions',
            sortable: false,
            align: 'right',
          },
        ]
      },
      actions () {
        return [
          // { color: 'info', icon: '$info' },
          { color: 'info', icon: '$list', tooltip: 'tooltip_edit', func: this.edit, disable: !this.editor },
          { color: 'edit', icon: '$email', tooltip: 'tooltip_balance_mail', func: this.sendMailBalance, disable: !this.editor },
        ]
      },
      page_title () { return this.$t('balances') },
      editor () { return this.profile.can['transaction-edit'] },
    },
    watch: {
      search: {
        handler () {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            this.options.page = 1
            this.load()
          }, 800)
        },
        deep: true,
      },
      options: {
        handler () {
          this.load()
        },
        deep: true,
      },
    },
    mounted () {
      // this.load()
    },
    methods: {
      getList: call('transaction/balance_list'),
      sendMail: call('transaction/send_mail_balance'),
      async load () {
        try {
          const { sortBy, sortDesc, page, itemsPerPage } = this.options
          await this.getList({
            page: page,
            per_page: itemsPerPage,
            sort: {
              field: sortBy,
              order: sortDesc,
            },
            search: this.search,
          }).then(response => {
            this.items = response.data
            this.total = response.total
          }).catch(e => {
            console.log(e)
          })
        } catch (e) {
        }
      },
      edit (userId) {
        this.$router.push(`/user/${userId}/transactions/`).catch(() => {})
      },
      async sendMailBalance (userId) {
        await this.sendMail({
          user_id: userId,
        }).then(response => {
          dispatch('alert/setSnackbar', { text: response, type: 'success' })
        }).catch(e => {
          alert(e.message())
        })
      },
      row_classes (item) {
        if (item.membership_balance < 0 || item.flight_balance < 0) {
          console.log(item.enable)
          return 'red lighten-5'
        }
      },
    },
  }
</script>
